var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-more" },
    [
      _c(
        "div",
        {
          staticClass: "menu--more-trigger",
          class: {
            "menu-more--active": _vm.menu_open == true
          }
        },
        [
          _c(
            "i",
            { staticClass: "material-icons", on: { click: _vm.openMenu } },
            [_vm._v("more_vert")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "menu--more-list",
          attrs: { name: "slideDown", tag: "div" }
        },
        [
          _vm.menu_open == true && _vm.hide_calendar !== true
            ? _c(
                "div",
                {
                  key: "calendar",
                  staticClass: "menu--more-list--item",
                  on: {
                    click: function($event) {
                      _vm.actionEvent("calendar")
                    }
                  }
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("event")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.menu_open == true && _vm.download.data.length > 0
            ? _c(
                "download-excel",
                {
                  key: "download",
                  staticClass: "menu--more-list--item",
                  attrs: {
                    name: _vm.download.name,
                    type: _vm.download.type,
                    fields: _vm.download.fields,
                    data: _vm.download.data
                  }
                },
                [
                  _c("i", { staticClass: "cursor-pointer material-icons" }, [
                    _vm._v("file_download")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f02b24e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f02b24e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/modules/ActionsMenuModule.vue
// module id = 640
// module chunks = 0